import React from "react";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import BaseChart from "../ui/BaseChart";
import ChartMetricsSelection from "../selection/ChartMetricsSelection";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatValue } from '@/lib/post_analysis_utils/formatValue';

export default function BenchmarkCharts({ 
  brandChartData, 
  regionChartData, 
  selectedMetric, 
  onMetricChange, 
  chartMetricOptions 
}) {
  // Get the type for the selected metric
  const selectedMetricType = chartMetricOptions.find(opt => opt.value === selectedMetric)?.type || 'number';
  const selectedMetricLabel = chartMetricOptions.find(opt => opt.value === selectedMetric)?.label || "Value";

  // Format values based on metric type
  const formatChartValue = (value) => {
    return formatValue(value, { type: selectedMetricType });
  };

  return (
    <>
      <div className="mb-4 flex items-center gap-2">
        <span className="font-medium">Chart Metric:</span>
        <ChartMetricsSelection
          value={selectedMetric}
          onChange={onMetricChange}
          options={chartMetricOptions}
        />
      </div>
      <div className="flex flex-col sm:flex-col md:flex-col lg:flex-row gap-6 mb-8">
        <div className="flex-1">
          <h2 className="text-xl font-semibold mb-2">Brand Chart</h2>
          <BaseChart
            data={brandChartData}
            xKey="label"
            yKey="value"
            type="bar"
            color="#2c7392"
            height={400}
            xLabel="Brand"
            yAxisFormatter={formatChartValue}
            tooltipFormatter={formatChartValue}
            legendLabel={selectedMetricLabel}
          />
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-semibold mb-2">Region Chart</h2>
          <BaseChart
            data={regionChartData}
            xKey="label"
            yKey="value"
            type="bar"
            color="#059669"
            height={400}
            xLabel="Region"
            yAxisFormatter={formatChartValue}
            tooltipFormatter={formatChartValue}
            legendLabel={selectedMetricLabel}
          />
        </div>
      </div>
    </>
  );
} 